import React, { useEffect, useState } from 'react';
import { mediaApi } from '@/api/mediaWrapper';
import type { MediaAssetResponse } from 'we-tree-api-client/v2';
import { formatRelativeTime } from '@/utils/formatRelativeTime';

interface OverviewPhotoThumbProps {
  familyId: string;
  asset: MediaAssetResponse;
  onClick: () => void;
}

const OverviewPhotoThumb: React.FC<OverviewPhotoThumbProps> = ({ familyId, asset, onClick }) => {
  const [displayUrl, setDisplayUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    mediaApi.getMediaDisplay(familyId, asset.id, '200x200').then((result) => {
      if (cancelled) return;
      if (result.success && result.data?.url) {
        setDisplayUrl(result.data.url);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [familyId, asset.id]);

  const label = asset.originalFilename || 'Photo';
  const when = formatRelativeTime(asset.createdAt);

  return (
    <button type="button" className="photo-thumb" onClick={onClick} title={label}>
      {displayUrl ? <img src={displayUrl} alt="" className="photo-thumb__img" /> : null}
      <span className="photo-thumb__overlay">{when}</span>
    </button>
  );
};

export default OverviewPhotoThumb;
